import Vue from 'vue'
import SvgIcon from './../Subassembly/SvgIcon'
Vue.component('svg-icon', SvgIcon)
//
const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)



// WEBPACK FOOTER //
// ./src/icons/index.js